module.exports = __webpack_public_path__ + "static/media/2 2 tattoo arm geisha hannya irezumi elegant stoic.1280x1707.1106c6df.webp";